const initPropertyHeroSeasons = () => {
  const tables = document.querySelectorAll('[data-hero-season-table]');

  tables.forEach((table) => {
    const rows = table.querySelector('[data-hero-season-rows]');
    const toggle = table.querySelector('[data-hero-season-toggle]');
    const label = table.querySelector('[data-hero-season-toggle-label]');
    const shell = table.closest('[data-hero-season-shell]');

    if (!rows || !toggle || !shell) {
      return;
    }

    const collapsedHeight = table.offsetHeight;
    shell.style.setProperty('--season-shell-collapsed-height', `${collapsedHeight}px`);
    shell.classList.add('is-floating');

    const setExpandedState = (isExpanded) => {
      table.classList.toggle('is-expanded', isExpanded);
      shell.classList.toggle('is-expanded', isExpanded);
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      if (label) {
        label.textContent = isExpanded ? 'Hide seasons' : 'View all seasons';
      }
    };

    setExpandedState(false);

    toggle.addEventListener('click', () => {
      const isExpanded = table.classList.contains('is-expanded');
      setExpandedState(!isExpanded);
    });
  });
};

export default initPropertyHeroSeasons;
